import React, { useState } from 'react';

import Tippy from '@tippyjs/react';

import { ia } from 'lib/helpers/utility';

import Button from 'components/shared/Buttons/Button';
import Allowed from 'components/shared/Permissions/Allowed';

import ChartExport from './ChartExport';

const ExportAction = ({ selectedRows }) => {
  const [showExport, setShowExport] = useState(false);
  return (
    <>
      <Allowed requiredPermissions="patients.export">
        <Tippy
          className="tippy-dark"
          content={
            selectedRows.length == 0
              ? 'Select at least one patient row to enable export'
              : 'EHI Export'
          }
          placement="top">
          <div>
            <Button
              icon="export-1-mono"
              outlined
              color="neutral"
              iconSize={16}
              className="!h-[30px] !w-[38px]"
              disabled={selectedRows.length == 0}
              onClick={() => setShowExport(true)}
            />
          </div>
        </Tippy>
      </Allowed>
      {showExport && ia(selectedRows) && (
        <ChartExport
          selectedRows={selectedRows.map((r) => r.data.id)}
          show={showExport}
          setShow={setShowExport}
        />
      )}
    </>
  );
};

export default ExportAction;
